var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _g, _g2, _path11, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOinqGive = function SvgOinqGive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Oinq_give_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 150.51 120.96",
    style: {
      enableBackground: "new 0 0 150.51 120.96"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Oinq_give_svg__st0{fill:#ad6a27}.Oinq_give_svg__st2{fill:#d08e4d}.Oinq_give_svg__st3{opacity:.23;enable-background:new}.Oinq_give_svg__st3,.Oinq_give_svg__st5{fill:#fff}.Oinq_give_svg__st6{fill:#191919}.Oinq_give_svg__st7{fill:#242929}.Oinq_give_svg__st8{fill:#dba876}")), /*#__PURE__*/React.createElement("g", {
    id: "Oinq_give_svg__Oinq_give",
    transform: "translate(-1238.165 -875.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oinq_give_svg__Friend_share",
    transform: "translate(1238.712 875.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oinq_give_svg__Group_2558",
    transform: "translate(0 36.153)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5072",
    className: "Oinq_give_svg__st0",
    d: "M11.78 31.7c.43-.85.77-1.74 1.04-2.66.36-1.12.61-2.06.76-2.72C6.61 27.7-1.72 20.28.31 13.59c.94-3.09 1.4-3.59 4.26-4.94a6.872 6.872 0 0 1 8.29 2.12c2.39 2.79 3.74 6.32 3.83 10 4.81-2.19 6.15-6.26 7.26-11.4.65-2.55.99-5.18 1.02-7.81l.63.14c1.78.36 3.62.14 5.26-.63-.58 8.45-3.69 17.16-10.24 21.76a19.58 19.58 0 0 1-3.44 2.25c-.27.14-.54.26-.82.38.1 2.44-.63 4.84-2.06 6.81-2.6 3.41-8.02 3.74-8.02 3.77.71-.11 1.39-.34 2.02-.69 1.49-.85 2.7-2.12 3.48-3.65zm.22-9.53c1.5-1.22 1.08-4.2-.92-6.66s-4.84-3.49-6.34-2.28-1.08 4.2.93 6.66 4.84 3.49 6.33 2.28z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5073",
    d: "m21.63 16.76-.07-.29c1.18-2.22 2-4.61 2.42-7.09.44-1.84.76-3.7.96-5.58l5.59.36c-1.05 7.43-4.16 14.66-9.91 18.69a19.58 19.58 0 0 1-3.44 2.25c-.26.14-.52.25-.79.37-1.65.3-2.76.44-2.76.44 3.32-1.38 8-9.15 8-9.15z",
    style: {
      opacity: 0.29,
      fill: "#191919",
      enableBackground: "new"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5074",
    className: "Oinq_give_svg__st2",
    d: "M24.49 24.4C19.77 18.05 13.16.86 25.2 1.07c10.25.18 20.08 5.31 23.18 7.05 12.47-3.64 24.63-3.28 26.09-3 8.76-.61 17.55.51 25.88 3.29 2.39-1.42 12.81-7.14 23.68-7.34 12.36-.22 5.05 17.9.33 23.8a50.9 50.9 0 0 1 3.78 5.45c17.41 28.8 4.94 71.27-30.68 82.6-14.16 4.5-59.49 8.5-74.94-19.35-11.92-21.52-7.13-54.21 1.97-69.17z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5075",
    className: "Oinq_give_svg__st0",
    d: "M24.65 24.09C20.29 18.4 14.31 3.87 22.52 1.46c-6.23 4.55 1.07 17.78 5.38 16.06 3.65-1.22 12.08-6.9 18.92-10.56.88.43 1.6.81 2.12 1.1h.04c-7.15 4.07-18.35 10.39-20.75 16.81-8.96 24-9.67 45.76 4.97 66.62 9.28 13.22 28.36 17.26 42.77 18.38 11.87 1.16 23.84-.2 35.14-4a56.88 56.88 0 0 1-12.24 5.39c-14.4 4.43-60.51 8.37-76.22-19.06-12.13-21.18-7.26-53.38 2-68.11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5076",
    className: "Oinq_give_svg__st3",
    d: "M89.41 9.87s34.56 9.7 41.11 31.05c5.46 17.71-2.91 43.18-21.46 54.34s-59.63 9.22-73.12-2.29c-17.25-14.7-8.23-27.35 3.77-27.88 0 0 15.51-5.87 21.33-.03 2.91 3.64 16.01 4.37 17.1-1.45 2.91-3.4 8.64-.99 21.83 2.54 5.85 1.56 17.01-11.91 3.46-21.23-16.85-11.6-65.73-9.55-76.11 7.02-7.85 12.51-11.64-27.11 5.82-34.88s37.71-9.62 56.27-7.19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5077",
    className: "Oinq_give_svg__st3",
    d: "M39.79 15.4S28.6 22.97 26.95 25.93c-2.63-.33-6.58-11.85-5.92-15.8s11.84-2.95 18.76 5.27z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5078",
    className: "Oinq_give_svg__st0",
    d: "M21.02 10.14c.05-.3.17-.59.35-.84.17-.25.4-.47.66-.63.37 4.01 1.26 10.23 5.18 10.94 3.69.82 8.55-2.91 11.77-5.11.27.29.54.59.8.91 0 0-11.19 7.57-12.84 10.53-2.62-.33-6.57-11.85-5.92-15.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5079",
    className: "Oinq_give_svg__st0",
    d: "M87.19 25.17c.2.03.41.01.6-.07.24-.09.47-.23.66-.4 9.47-7.9 13.08-2.64 13.23-2.42.07.1.17.17.28.21.14.04.28.04.42.02.37-.08.71-.27.98-.53.3-.26.54-.6.7-.97.13-.27.13-.58 0-.84-.05-.07-4.73-6.88-16.46 2.92-.3.25-.54.57-.7.93-.14.26-.16.57-.06.85.07.14.2.25.35.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5080",
    className: "Oinq_give_svg__st0",
    d: "M118.36 37.7c.09.08.21.12.33.12.18-.04.32-.19.37-.37.08-.25.1-.52.06-.78-1.81-10.87-7.58-10.98-7.64-10.98-.08 0-.16.03-.23.09a.66.66 0 0 0-.17.24c-.05.12-.08.24-.09.36a2.07 2.07 0 0 0 .11.86c.05.13.11.25.19.36.06.09.14.18.24.24.07.05.16.08.25.09.19 0 4.65.14 6.11 8.86.03.19.09.37.18.54.06.15.16.27.29.37z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oinq_give_svg__Path_5081_00000004517515241017719130000016496265660523507115_",
    gradientUnits: "userSpaceOnUse",
    x1: -211.591,
    y1: 442.479,
    x2: -211.591,
    y2: 441.479,
    gradientTransform: "matrix(39.7729 0 0 -6.218 8493.142 2756.829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#242929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#242929"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5081",
    style: {
      fill: "url(#Oinq_give_svg__Path_5081_00000004517515241017719130000016496265660523507115_)"
    },
    d: "M97.43 11.71H91.3S66.57 4.64 57.65 6.15c0 0 15.61-3.48 39.78 5.56z"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5082",
    className: "Oinq_give_svg__st0",
    d: "M92.84 11.66S74.41 6.67 65.1 5.87s-2.38-.07-2.38-.07 22.78 4.12 25.7 6.4l4.42-.54z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5083",
    className: "Oinq_give_svg__st0",
    d: "M100.51 11.32S82.08 6.57 72.77 5.81s-2.38-.06-2.38-.06 22.78 3.92 25.7 6.08l4.42-.51z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_give_svg__Ellipse_191",
    className: "Oinq_give_svg__st5",
    cx: 111.12,
    cy: 40.16,
    rx: 4.73,
    ry: 7.95
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oinq_give_svg__Ellipse_192",
    className: "Oinq_give_svg__st5",
    cx: 99.7,
    cy: 37.82,
    rx: 5.61,
    ry: 9.43
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_give_svg__Group_2559",
    transform: "translate(109.431 36.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5084",
    className: "Oinq_give_svg__st6",
    d: "M2.81 9.54C1.26 9.54 0 7.64 0 5.31s1.26-4.23 2.81-4.23 2.82 1.9 2.82 4.23-1.26 4.23-2.82 4.23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5085",
    className: "Oinq_give_svg__st7",
    d: "M1.06 4.83c-.32 1.49.18 3.04 1.31 4.06-.34.03-.68-.08-.93-.31-.31-.28-.53-.64-.65-1.04C.65 7.08.6 6.6.64 6.12c.04-.45.18-.89.42-1.29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5086",
    className: "Oinq_give_svg__st5",
    d: "M2.61 5.64c-.34 0-.61-.41-.61-.92s.27-.92.61-.92.61.41.61.92-.28.92-.61.92z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_give_svg__Group_2560",
    transform: "translate(97.232 33.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5087",
    className: "Oinq_give_svg__st6",
    d: "M3.34 11.12C1.49 11.12 0 8.87 0 6.09s1.5-5.02 3.34-5.02 3.34 2.25 3.34 5.02-1.5 5.03-3.34 5.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5088",
    className: "Oinq_give_svg__st7",
    d: "M1.25 5.53c-.37 1.77.22 3.6 1.56 4.81-.4.04-.8-.09-1.1-.36-.36-.34-.63-.77-.77-1.24C.77 8.2.71 7.63.77 7.06c.04-.54.21-1.06.48-1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5089",
    className: "Oinq_give_svg__st5",
    d: "M3.09 6.49c-.4 0-.73-.49-.73-1.09s.32-1.09.73-1.09.73.49.73 1.09-.33 1.09-.73 1.09z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5105",
    d: "M80.83 72.19S55.09 93.27 48.78 60.43s32.05 11.76 32.05 11.76z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Oinq_give_svg__Group_2561",
    transform: "translate(72.788 45.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5090",
    className: "Oinq_give_svg__st0",
    d: "M53.43 6.85c.76.33 1.49.71 2.21 1.12 1.83 1.05 3.55 2.27 5.15 3.64 2.25 1.91 4.24 4.12 5.91 6.55 2.06 3.01 3.59 6.35 4.53 9.88.75 2.78.99 5.67.72 8.53a19.53 19.53 0 0 1-2.39 7.88 11.86 11.86 0 0 1-5.64 5.15c-2.9 1.11-6.09 1.21-9.06.29-3.62-.96-6.87-1.73-9.84-2.32s-5.68-1-8.2-1.25c-2.36-.24-4.74-.32-7.11-.25-2.21.08-4.42.3-6.6.67-2.31.37-4.66.43-6.99.19-2.4-.23-4.75-.79-7-1.65a16.96 16.96 0 0 1-5.67-3.49 9.836 9.836 0 0 1-2.96-5.3 30.9 30.9 0 0 1-.46-6.86c.11-2.57.53-5.11 1.28-7.57.79-2.62 1.99-5.1 3.55-7.35a24.12 24.12 0 0 1 6.34-6.2c2.71-1.83 5.63-3.32 8.69-4.43 3.25-1.19 6.65-1.93 10.1-2.2 3.77-.29 7.56-.05 11.26.71 4.23.88 8.32 2.31 12.18 4.26z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5091",
    className: "Oinq_give_svg__st2",
    d: "M68.8 33.93c-.01.69-.06 1.38-.16 2.06-.2 1.55-.6 3.06-1.2 4.5-.69 1.74-1.84 3.26-3.32 4.41a9.9 9.9 0 0 1-6.54 1.79c-2.65-.13-5.28-.47-7.88-1.02-2.5-.5-4.96-1.1-7.66-1.64-3.02-.62-6.07-1.04-9.15-1.25-4.14-.26-8.3-.2-12.43.17-4.91.41-8.6-.15-11.3-1.4a10.112 10.112 0 0 1-5.34-5.49c-.91-2.47-1.18-5.13-.78-7.74.38-2.8 1.16-5.53 2.31-8.12 1.21-2.67 2.95-5.06 5.12-7.03 2.37-2.18 5.08-3.98 8.01-5.33a37.29 37.29 0 0 1 9.94-3c3.62-.56 7.31-.59 10.94-.09 3.69.5 7.29 1.5 10.7 2.98 3.34 1.44 6.43 3.41 9.14 5.84 2.73 2.46 4.96 5.41 6.57 8.71 1.77 3.67 2.79 7.62 3.03 11.65z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5092",
    className: "Oinq_give_svg__st8",
    d: "M52.2 30.18c-.03.72.05 1.44.25 2.13.18.63.46 1.23.84 1.77.35.49.79.91 1.3 1.23.49.3 1.05.48 1.63.51.57.03 1.15-.09 1.66-.35.53-.26 1-.64 1.38-1.09.42-.5.74-1.06.97-1.67.25-.67.39-1.37.41-2.09.03-.72-.05-1.43-.25-2.12-.18-.63-.46-1.23-.83-1.77-.34-.49-.78-.91-1.3-1.23a3.6 3.6 0 0 0-1.63-.52 3.42 3.42 0 0 0-1.66.34c-.54.26-1.01.63-1.4 1.09-.42.5-.75 1.07-.98 1.68-.22.66-.37 1.37-.39 2.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5093",
    className: "Oinq_give_svg__st7",
    d: "M50.69 31.59c-.03.72.05 1.44.25 2.13.18.64.46 1.23.84 1.77.35.49.79.91 1.3 1.23.49.3 1.05.48 1.63.51.58.03 1.15-.09 1.67-.35.53-.27 1.01-.64 1.39-1.1.42-.5.75-1.07.97-1.68.25-.67.39-1.38.41-2.09.03-.72-.06-1.43-.25-2.12-.18-.63-.46-1.23-.84-1.77-.34-.49-.78-.91-1.3-1.23a3.6 3.6 0 0 0-1.63-.52c-.57-.03-1.15.09-1.66.34-.54.26-1.01.63-1.4 1.09-.42.5-.75 1.07-.98 1.68-.24.68-.38 1.39-.4 2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5094",
    className: "Oinq_give_svg__st8",
    d: "M14.16 26.32c-.03.74.06 1.47.26 2.18.19.65.49 1.27.88 1.82.36.51.83.94 1.36 1.26.51.31 1.09.49 1.69.52a3.5 3.5 0 0 0 1.72-.35c.55-.27 1.05-.65 1.45-1.11.44-.51.78-1.08 1.02-1.71.26-.68.41-1.4.44-2.13.03-.73-.06-1.46-.26-2.17-.18-.65-.48-1.26-.87-1.81-.36-.51-.82-.94-1.35-1.26-.51-.31-1.1-.5-1.7-.53-.6-.03-1.2.08-1.74.34-.56.26-1.05.64-1.45 1.11a5.71 5.71 0 0 0-1.02 1.71c-.26.68-.41 1.4-.43 2.13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oinq_give_svg__Path_5095",
    className: "Oinq_give_svg__st7",
    d: "M12.57 27.77c-.03.74.06 1.47.26 2.18.19.65.49 1.27.88 1.82.36.51.83.94 1.36 1.26.52.31 1.1.49 1.71.52.6.03 1.2-.09 1.74-.35.56-.27 1.05-.65 1.45-1.12.44-.51.78-1.09 1.01-1.71.26-.68.4-1.41.43-2.14.03-.73-.05-1.47-.25-2.17-.19-.65-.48-1.26-.87-1.81-.36-.51-.82-.94-1.36-1.26-.51-.31-1.1-.5-1.7-.53-.6-.03-1.2.08-1.74.34-.56.26-1.05.64-1.46 1.11a5.51 5.51 0 0 0-1.02 1.71c-.26.68-.41 1.41-.44 2.15z"
  }))))));
};
export default SvgOinqGive;